import agrochemicalRestService from '../services/agrochemical/AgrochemicalRestService'
import agrochemicalUtilFunctions from '../services/agrochemical/AgrochemicalUtilsFunctions'

const state = {
  agrochemicals: [],
  agrochemicalNameList: [],
  itemsToWithdraw: [],
  itemsToApply: [],
  withdrawedAgrochemicals: [],
  agroApplications: [],
  isWithdrawDialogActived: false,
  dialogActived: false,
  selectedItem: {},
  editApplicationDialogActived: false,
  applyAgrochemicalDialogActived: false,
  selectedApplicationItem: {},
  applicationDetails: [],
  defaultItem: {
    id: -1,
    name: '',
    nota: '',
    amount: null,
    measurementUnit: null,
    modificationDate: null,
    expirationDate: null,
    purchaseDate: null,
    activePrincipie: '',
    principeActiveConcentration: null,
    price: null,
    laboratory: '',
    bill: '',
    batchCode: null,
    agrochemicalType: null
  },
  defaultApplicationItem: {
    id: -1,
    items: [],
    applicationNumber: null,
    applicationType: null,
    haAmount: null,
    landBatch: {
      id: null,
      name: '',
      haAmount: '',
      note: ''},
    applicationDate: null
  }
}

const getters = {
  getAgrochemicals: state => state.agrochemicals,
  isDialogActived: state => state.dialogActived,
  getSelectedItem: state => state.selectedItem,
  getDefaultItem: state => state.defaultItem,
  getAgrochemicalNamesList: state => state.agrochemicalNameList,
  isWithdrawDialogActived: state => state.isWithdrawDialogActived,
  getItemsToWithdraw: state => state.itemsToWithdraw,
  getItemsToApply: state => state.itemsToApply,
  getWithdrawedAgrochemicals: state => state.withdrawedAgrochemicals,
  getAgroApplications: state => state.agroApplications,
  getSelectedApplicationItem: state => state.selectedApplicationItem,
  isEditApplicationDialogActived: state => state.editApplicationDialogActived,
  isApplyAgrochemicalDialogActived: state => state.applyAgrochemicalDialogActived,
  getDefaultApplicationItem: state => state.defaultApplicationItem,
  getApplicationDetails: state => state.applicationDetails
}

const actions = {
  async getAgrochemicals (context) {
    try {
      let data = await agrochemicalRestService.getAgrochemicals()
      context.commit('setAgrochemicals', data)
    } catch (e) {
      console.log('Error fetching Agrochemicals')
    }
  },
  async getAgroApplications (context) {
    try {
      let data = await agrochemicalRestService.getAgroApplications()
      context.commit('setAgroApplications', data)
    } catch (e) {
      console.log('Error fetching Agrochemicals Applications')
    }
  },
  async getWithdrawedAgrochemicals (context) {
    try {
      let data = await agrochemicalRestService.getWithdrawedAgrochemicals()
      context.commit('setWithdrawedAgrochemicals', data)
    } catch (e) {
      console.log('Error fetching withdrawed Agrochemicals')
    }
  },
  async getAgrochemicalNamesList (context) {
    try {
      let data = await agrochemicalRestService.getAgrochemicalNamesList()
      context.commit('setAgrochemicalNameList', data)
    } catch (e) {
      console.log('Error fetching Agrochemicals Names.')
    }
  },
  async saveAgrochemical (context, agrochemicalInfo) {
    let snackBarContent = {actived: true, message: 'Agroquimico Agregado/Modificado Exitosamente.', color: 'success'}
    try {
      await agrochemicalRestService.saveAgrochemical(agrochemicalInfo)
    } catch (e) {
      snackBarContent = {actived: true, message: 'Error al intentar Agregar/Modificar Agroquimico.', color: 'error'}
    }
    context.commit('setSnackBarStatus', snackBarContent, {root: true})
  },
  async saveAgroApplication (context, aplicationInfo) {
    let snackBarContent = {actived: true, message: 'Aplicación de Agroquimico Agregado/Modificado Exitosamente.', color: 'success'}
    try {
      await agrochemicalRestService.saveAgroApplication(aplicationInfo)
    } catch (e) {
      snackBarContent = {actived: true, message: 'Error al intentar Agregar/Modificar Aplicación de Agroquimico.', color: 'error'}
    }
    context.commit('setSnackBarStatus', snackBarContent, {root: true})
  },
  async saveAgroApplicationDetail (context, item) {
    let snackBarContent = {actived: true, message: 'Agroquimico Aplicado Modificado Exitosamente.', color: 'success'}
    try {
      await agrochemicalRestService.saveAgroApplicationDetail(item)
    } catch (e) {
      snackBarContent = {actived: true, message: 'Error al intentar Modificar Agroquimico Aplicado.', color: 'error'}
    }
    context.commit('setSnackBarStatus', snackBarContent, {root: true})
  },
  async withdrawAgrochemical (context, withdrawOrder) {
    let snackBarContent = {actived: true, message: 'Agroquimico/s Retirado/s Exitosamente.', color: 'success'}
    try {
      await agrochemicalRestService.withdrawAgrochemical(withdrawOrder)
    } catch (e) {
      snackBarContent = {actived: true, message: 'Error al intentar Retirar Agroquimico/s.', color: 'error'}
    }
    context.commit('setSnackBarStatus', snackBarContent, {root: true})
  },
  async addAgrochemicalStock (context, agrochemicalInfo) {
    let snackBarContent = {actived: true, message: 'Stock Modificado Exitosamente.', color: 'success'}
    try {
      await agrochemicalRestService.addAgrochemicalStock(agrochemicalInfo)
    } catch (e) {
      snackBarContent = {actived: true, message: 'Error Actualizando Stock.', color: 'error'}
    }
    context.commit('setSnackBarStatus', snackBarContent, {root: true})
  },
  async deleteAgrochemical (context, id) {
    let snackBarContent = {actived: true, message: 'Agroquimico Eliminado Exitosamente.', color: 'success'}
    try {
      await agrochemicalRestService.deleteAgrochemical(id)
      context.commit('setSnackBarStatus', snackBarContent, {root: true})
    } catch (error) {
      if (error.response.status === 424) {
        let notiDialogValue = {
          actived: true,
          title: 'Imposible borrar el agroquimico seleccionado',
          body: agrochemicalUtilFunctions.getDependenciesMsg(error.response.data) }
        context.commit('setNotificationDialog', notiDialogValue, {root: true})
      } else {
        snackBarContent = {actived: true, message: 'Hubo un problema eliminado el agroquimico seleccionado.', color: 'error'}
        context.commit('setSnackBarStatus', snackBarContent, {root: true})
      }
    }
  },
  async deleteAgroApplication (context, id) {
    let snackBarContent = {actived: true, message: 'Registro Eliminado Exitosamente.', color: 'success'}
    try {
      await agrochemicalRestService.deleteAgroApplication(id)
    } catch (error) {
      snackBarContent = {actived: true, message: 'Hubo un problema eliminado el registro seleccionado.', color: 'error'}
    }
    context.commit('setSnackBarStatus', snackBarContent, {root: true})
  },
  async deleteAgroApplicationDetail (context, id) {
    let snackBarContent = {actived: true, message: 'Item Eliminado Exitosamente.', color: 'success'}
    try {
      await agrochemicalRestService.deleteAgroApplicationDetail(id)
    } catch (error) {
      snackBarContent = {actived: true, message: 'Hubo un problema eliminado el item seleccionado.', color: 'error'}
    }
    context.commit('setSnackBarStatus', snackBarContent, {root: true})
  },
  async getApplicationDetails (context, id) {
    try {
      let data = await agrochemicalRestService.getApplicationDetails(id)
      context.commit('setApplicationDetails', data)
    } catch (e) {
      console.log('Error fetching Application Details.')
    }
  },
  setDialogActived (context, active) {
    context.commit('setDialogActived', active)
  },
  setWithdrawDialogActived (context, active) {
    context.commit('setWithdrawDialogActived', active)
  },
  setSelectedItem (context, selectedItem) {
    context.commit('setSelectedItem', selectedItem)
  },
  setItemsToWithdraw (context, items) {
    context.commit('setItemsToWithdraw', items)
  },
  setItemsToApply (context, items) {
    context.commit('setItemsToApply', items)
  },
  refreshFilteredAgrochemicals (context) {
    context.commit('refreshFilteredAgrochemicals')
  },
  setSelectedApplicationItem (context, item) {
    context.commit('setSelectedApplicationItem', item)
  },
  setEditApplicationDialogActived (context, active) {
    context.commit('setEditApplicationDialogActived', active)
  },
  setApplyAgrochemicalsDialogActived (context, active) {
    context.commit('setApplyAgrochemicalsDialogActived', active)
  }

}

const mutations = {
  setAgrochemicals (state, data) {
    state.agrochemicals = data
  },
  setWithdrawedAgrochemicals (state, data) {
    state.withdrawedAgrochemicals = data
  },
  setAgrochemicalNameList (state, data) {
    state.agrochemicalNameList = data
  },
  setAgroApplications (state, data) {
    state.agroApplications = data
  },
  setDialogActived (state, active) {
    state.dialogActived = active
  },
  setWithdrawDialogActived (state, active) {
    state.isWithdrawDialogActived = active
  },
  setSelectedItem (state, selectedItem) {
    state.selectedItem = selectedItem
  },
  setItemsToWithdraw (state, items) {
    state.itemsToWithdraw = items
  },
  setItemsToApply (state, items) {
    state.itemsToApply = items
  },
  setSelectedApplicationItem (state, item) {
    state.selectedApplicationItem = item
  },
  setEditApplicationDialogActived (state, active) {
    state.editApplicationDialogActived = active
  },
  setApplyAgrochemicalsDialogActived (state, active) {
    state.applyAgrochemicalDialogActived = active
  },
  setApplicationDetails (state, data) {
    state.applicationDetails = data
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
